export default __webpack_public_path__ + "static/media/donation_gold.4a27b211.svg";